<template>
<div class="container">

    <div class="row justify-content-center mt-4 pb-4 mb-2 pt-4">
        <div class="col-12 col-xl-8 text-center"> 
            <h2 class="font-glacial-bold">{{data.titulo}}</h2>
        </div>
    </div>

    <div class="text-center text-sm-left font-galcial-regular pb-2 font-sub-22" v-html="data.texto"></div>

</div>
    
</template>


<script>
    export default {
        props:{
            data: null
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/widgets/texto_titulo_centralizado.vue